
import DesignContentLayout from '@/layouts/design/DesignContentLayout';

export default {
  name: 'DesignComponentsProductData',
  components: { DesignContentLayout }
};
